// Amplitude event taxonomy — canonical event names, property keys, and runtime validation.

export type AnalyticsPropertyValue = string | number | boolean | null;

/** Minimal Amplitude event shape for plugin use (avoids importing internal SDK types). */
export interface AmplitudeEvent {
  event_type: string;
  event_properties?: Record<string, unknown>;
  [key: string]: unknown;
}

const EVENT_PROPERTIES = {
  'Beta UI Reverted': ['Current Route'],
  'Device Details Opened': ['Device Kind', 'Device Alias'],
  'Device Mode Changed': ['Device Kind', 'Device Alias', 'Previous Device Mode', 'Device Mode'],
} as const;

/** Valid Amplitude event names for gaia. */
export type AmplitudeEventName = keyof typeof EVENT_PROPERTIES;

type EventPropertyName<E extends AmplitudeEventName> = (typeof EVENT_PROPERTIES)[E][number];

/** Allowed properties per event. */
export type AmplitudeEventPropertyMap = {
  [E in AmplitudeEventName]: Partial<Record<EventPropertyName<E>, AnalyticsPropertyValue>>;
};

/** Enrichment properties auto-attached to every event. */
export interface AmplitudeEnrichmentProperties {
  Organization?: string;
  Agent?: string;
}

/** User properties set via Amplitude Identify. */
export interface AmplitudeUserProperties {
  UUID?: string;
  'Display Name'?: string;
  Email?: string;
}

// --------------- Runtime validation sets ---------------

export const EVENTS: Set<string> = new Set(Object.keys(EVENT_PROPERTIES));

export const PROPERTIES: Record<string, Set<string>> = Object.fromEntries(
  Object.entries(EVENT_PROPERTIES).map(([event, properties]) => [event, new Set(properties)])
);
